// Tipo de servicios

export function getServiceTypes() {
  return [
    { value: "APARTMENT_BUILDING", label: "Edificio" },
    { value: "FACTORY", label: "Fábrica" },
    { value: "RESIDENTIAL_AREA", label: "Zona residencial" },
    { value: "SHOPPING_CENTER", label: "Centro comercial" },
    { value: "BUSINESS", label: "Empresarial" },
    { value: "COMMERCIAL", label: "Zona comercial" },
    { value: "HOUSING_DEVELOPMENT", label: "Fraccionamiento" },
    { value: "HOTEL", label: "Hotelera" },
    { value: "GAS_STATION", label: "Gasolinera" },
    { value: "SCHOOL", label: "Escuela" },
    { value: "GOVERNMENT_INSTITUTION", label: "Institución gubernamental" },
    { value: "OTHER", label: "Otro" }
  ];
}

export function getServiceTypeLabel(serviceType) {
  const type = getServiceTypes().find((t) => t.value === serviceType);
  return type ? type.label : serviceType;
}